// extracted by mini-css-extract-plugin
export var carrierIcon = "_yh-0";
export var carrierLogo = "_yh-1";
export var detailsSection = "_yh-2";